import { MadadInfoSection } from './madad-info';

export default MadadInfoSection;
